/**
 * HTTP 错误类
 * 用于封装 HTTP 请求的错误信息
 */
export class HttpError extends Error {
  /** HTTP 状态码 */
  public readonly statusCode: number
  /** 业务错误码 */
  public readonly code: number
  /** 错误消息 */
  public readonly message: string
  /** 响应数据 */
  public readonly data?: unknown

  constructor(statusCode: number, code: number, message: string, data?: unknown) {
    super(message)
    this.name = "HttpError"
    this.statusCode = statusCode
    this.code = code
    this.message = message
    this.data = data

    // 保持原型链正确
    Object.setPrototypeOf(this, HttpError.prototype)
  }

  /**
   * 判断是否为 HTTP 错误
   */
  static isHttpError(error: unknown): error is HttpError {
    return error instanceof HttpError
  }

  /**
   * 获取用户友好的错误消息
   */
  getUserMessage(): string {
    return this.message || "请求失败，请稍后重试"
  }

  /**
   * 转换为 JSON 对象
   */
  toJSON() {
    return {
      name: this.name,
      statusCode: this.statusCode,
      code: this.code,
      message: this.message,
      data: this.data,
    }
  }
}
